// material ui
import { useTheme } from '@mui/material/styles';

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import 'highcharts/highcharts-more';

function parseTimestamp(ts) {
  // Try to parse ISO string, fallback to 0 if invalid
  const d = Date.parse(ts);
  return isNaN(d) ? 0 : d;
}

const NodeTimeRangeGraph = ({ energyData = [] }) => {
  const theme = useTheme();

  if (energyData?.NodeEnergySummaries === undefined) return null;
  // Prepare data for columnrange: [x, min, max]
  const categories = energyData.NodeEnergySummaries.map((node) => node.Name);
  const data = energyData.NodeEnergySummaries.map((node, idx) => {
    const min = parseTimestamp(node.TimestampsSummary.minEarliestDataTimestamp);
    const max = parseTimestamp(node.TimestampsSummary.maxLatestDataTimestamp);
    return {
      x: idx,
      low: min,
      high: max,
      name: node.Name,
    };
  });

  const options = {
    chart: {
      type: 'columnrange',
      inverted: true,
      height: Math.max(300, energyData.NodeEnergySummaries.length * 50),
      backgroundColor: theme.palette.background.paper,
    },
    title: {
      text: 'Node Data Time Ranges',
      style: {
        color: theme.palette.text.primary,
      },
    },
    xAxis: {
      categories,
      title: {
        text: 'Node',
        // style: {
        //   color: theme.palette.text.primary,
        // },
      },
      labels: {
        style: {
          color: theme.palette.text.secondary,
        },
      },
      lineColor: theme.palette.divider,
      tickColor: theme.palette.divider,
    },
    yAxis: {
      type: 'datetime',
      title: {
        text: 'Timestamp',
        style: {
          color: theme.palette.text.primary,
        },
      },
      labels: {
        style: {
          color: theme.palette.text.secondary,
        },
      },
      gridLineColor: theme.palette.divider,
    },
    tooltip: {
      backgroundColor: theme.palette.background.paper,
      borderColor: theme.palette.divider,
      style: {
        color: theme.palette.text.primary,
      },
      pointFormat:
        '<b>{point.name}</b><br/>From: {point.low:%Y-%m-%d %H:%M}<br/>To: {point.high:%Y-%m-%d %H:%M}',
    },
    series: [
      {
        name: 'Data Range',
        data,
      },
    ],
    plotOptions: {
      columnrange: {
        dataLabels: {
          enabled: true,
          formatter: function () {
            return Highcharts.dateFormat('%Y-%m-%d', this.y);
          },
          style: {
            color: theme.palette.text.primary,
            textOutline: 'none',
          },
        },
      },
    },
    credits: { enabled: false },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default NodeTimeRangeGraph;
